import { combineReducers } from "@reduxjs/toolkit";
import {
  businessMetadataApi,
  projectsAndCategoriesApi,
  spreedlyCredentialsApi,
  userApi,
} from "@capone/common";
import { reducer as packagesRewards } from "../modules/rewards/reducer";
import { reducer as packagesSearch } from "../modules/search/reducer";
import { reducer as packagesAvailability } from "../modules/availability/reducer";
import { reducer as packageHotelShop } from "../modules/hotel-shop/reducer";
import { reducer as packagesTravelWallet } from "../modules/travel-wallet/reducer";
import { reducer as packagesFlightShop } from "../modules/flight-shop/reducer";
import { reducer as packagesItineraryReview } from "../modules/itinerary-review/reducer";
import { reducer as packagesBook } from "../modules/book/reducer";
import { reducer as packageIdentity } from "../modules/package-identity/reducer";

export const rootReducer = combineReducers({
  packagesRewards,
  packagesSearch,
  packagesAvailability,
  packageHotelShop,
  packagesTravelWallet,
  packagesFlightShop,
  packagesItineraryReview,
  packagesBook,
  packageIdentity,
  [userApi.reducerPath]: userApi.reducer,
  [spreedlyCredentialsApi.reducerPath]: spreedlyCredentialsApi.reducer,
  [businessMetadataApi.reducerPath]: businessMetadataApi.reducer,
  [projectsAndCategoriesApi.reducerPath]: projectsAndCategoriesApi.reducer,
});
